import { z } from "zod";

export enum ParameterListValueTypeEnum {
    TEXT = 1,
    NUMBER = 2,
}

export const ParameterListValueTypeEnumSchema = z.nativeEnum(ParameterListValueTypeEnum);
export type ParameterListValueTypeEnumSchema = z.infer<typeof ParameterListValueTypeEnumSchema>;